var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"\n    text-white\n    bg-gray-900\n    rounded-2xl\n    h-full\n  ",class:[
    _vm.style[_vm.mobilePosition],
    _vm.open
      ? 'duration-500 ease-in transition-all'
      : 'duration-700 ease-out hidden transition-all lg:w-24' ]},[_c('div',[_c('sidenav-header'),_c('sidenav-items')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }